import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useIsRouteFeatureOff } from '@/brands';
import { NotFoundPage } from '@/pages/NotFoundPage';

/**
 * Brand Features, enforced at the router.
 *
 * The sibling `MenuGate` closes a URL whose every menu link the super admin
 * hid; this one closes a URL whose whole *product* they revoked. It wraps the
 * entire route table rather than sitting inside it as a layout route, because a
 * revoked product spans every branch at once — `/register` under the auth
 * layout, the cashier under `ProtectedRoute`, the lobby under `CasinoLayout` —
 * and threading one more pathless parent through all of them would only be the
 * same test written four times.
 *
 * `SiteGate` holds its splash until GET /brand resolves, so by the time this
 * runs the flags are the brand's real ones — no window where a revoked page
 * paints first and blinks out. The server refuses the matching API calls and
 * withholds their data independently, so this is reachability, not the access
 * control itself.
 */
export function FeatureGate({ children }: { children: ReactNode }) {
  const { pathname } = useLocation();
  return useIsRouteFeatureOff(pathname) ? <NotFoundPage /> : <>{children}</>;
}
